import React from 'react';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';
import { userHasExpenseEnabledRedir } from '../core/auth';
import ExpensesDetail from '../views/expenseDetail/containers/ExpenseDetail';
import PurchaseOrders from '../views/expenses/containers/PurchaseOrders';

const PurchasesRoute = () => {
  return (
    <Switch>
      <Route exact path="/:site/purchases">
        <PurchaseOrders />
      </Route>
      <Route path="/:site/purchases/:expense">
        <ExpensesDetail />
      </Route>
    </Switch>
  );
};

export default userHasExpenseEnabledRedir(PurchasesRoute);
